//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState, useEffect } from 'react';

// *** MUI / STYLE ***
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

// === API ===
import { on, removeListener } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function useAlert() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const [   title , setTitle   ] = useState( '' );
  const [ message , setMessage ] = useState( '' );
  const [     open, setOpen    ] = useState(false);

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleAlert( data ) {
      //-----------------------------------------------------------------
      setTitle  ( data.title   );
      setMessage( data.message );
      setOpen   ( true );
    }

    on( 'ALERT', handleAlert );

    return () => {
      removeListener( 'ALERT', handleAlert );
    };
  }, [] );

  //#endregion

  //#region [EVENTS]

  function handleClose() {
    setOpen(false);
  };

  //#endregion

  function alert() {
    return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  return alert;
}